package `fun`.adaptive.grove.hydration.lfm

abstract class LfmExpression